module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921015651_T.a600dabb.jpg";